import React from 'react';
import { useTranslation } from 'react-i18next'
import { A } from '../common';
import { URL } from '../../constant';
import { useAppOcrOnOff, useProfessorK } from '../../hooks';

import Header from './aibarosam/Header';
import PMNotice from './aibarosam/PMNotice';


function SelectLearningGMV2(props) {
  
  const { t } = useTranslation();
  const { handleOcr } = useAppOcrOnOff();
  const {handleProfessorKOpen} = useProfessorK();

  return (
    <React.Fragment>
      <Header />
      <div className="layout-def with_bottom_area choice gm new flex_main">
        <div className="container">
          <div className="inner">
            <div className="center_wrap">
              <PMNotice />
              <div className="boxes_wrap">
                <A
                  className="box1 js_play_audio1"
                  onClick={ 
                    () => props.handlePage(URL.PROGRESS_LEARNING.AI_BAROSEM)
                  }
                >
                  <span className="tit">{t("LC_01_02-GM.msg003")}</span>
                  <span className="btn">{t("LC_01_02-GM.msg004")}</span>
                </A>
                <A
                  className="box2"
                  href="#null"
                  onClick={() => props.handlePage(URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.ENTER_LEARNER_DATA)}
                >
                  {t("LC_01_02-GM.msg007")}
                </A>
                <A
                  className="box3 js_play_audio1"
                  onClick={() => props.handlePage(URL.TOPIC_LEARNING)}
                >
                  <span>{t("LC_01_02-GM.msg005")}</span>
                </A>
                <A
                  className="box4"
                  onClick={handleOcr}
                >
                  <span>{t("LC_01_02-GM.msg006")}</span>
                </A>
              </div>
              <div class="banner_wrap">
                <A class="banner_link" onClick={handleProfessorKOpen}>
                  <span class="blind">프로페서 K 시간 여행으로 즐기는 사고력 수학 - 시작하기</span>
                </A>

                <A class="b_product_link" onClick={() => props.handlePage(URL.INTRODUCTION)}>
                  <span class="b_product_link_badge">제품소개 바로가기</span>
                  <p class="b_product_link_tit">강력한 AI 기술로 완성된</p>
                  <p class="b_product_link_subtit">새로운 연산 학습법! AI 바로셈!</p>
                </A>
              </div>
            </div>
            <div className="bottom_wrap btn_wrap flexible_bottom_banner">
              <div className="box_btn">
                <span className="inner_box cls">
                  <span className="left">
                    <span className="txt1">{t("LC_01_02-GM.msg008")}</span>
                    <span className="txt2">{t("LC_01_02-GM.msg009")}</span>
                  </span>
                  <A
                    className="right"
                    onClick={() => props.handlePage(URL.INTRODUCTION)}
                  >
                    {t("LC_01_02-GM.msg010")}
                  </A>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default SelectLearningGMV2;